// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"da0fc5a6","143":"f23ad7f8"}[chunkId] + ".css";
};